// extracted by mini-css-extract-plugin
export default {"cls1":"sUWyso79GJvBFFhE3haz","cls2":"j6_gPiy8MUWKXIJ5WT2S sUWyso79GJvBFFhE3haz"};